/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Schedule_ViewingInputs */

const en_schedule_viewing = /** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule Viewing`)
};

const id_schedule_viewing = /** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwalkan Penayangan`)
};

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const es_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const fr_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const de_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const ja_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const zh_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const ar_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const it_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const ru_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const pt_schedule_viewing = en_schedule_viewing;

/** @type {(inputs: Schedule_ViewingInputs) => LocalizedString} */
const ko_schedule_viewing = en_schedule_viewing;

/**
* | output |
* | --- |
* | "Schedule Viewing" |
*
* @param {Schedule_ViewingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const schedule_viewing = /** @type {((inputs?: Schedule_ViewingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Schedule_ViewingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_schedule_viewing(inputs)
	if (locale === "es") return es_schedule_viewing(inputs)
	if (locale === "fr") return fr_schedule_viewing(inputs)
	if (locale === "de") return de_schedule_viewing(inputs)
	if (locale === "ja") return ja_schedule_viewing(inputs)
	if (locale === "zh") return zh_schedule_viewing(inputs)
	if (locale === "ar") return ar_schedule_viewing(inputs)
	if (locale === "id") return id_schedule_viewing(inputs)
	if (locale === "it") return it_schedule_viewing(inputs)
	if (locale === "ru") return ru_schedule_viewing(inputs)
	if (locale === "pt") return pt_schedule_viewing(inputs)
	return ko_schedule_viewing(inputs)
});